const providers = ["Día", "amazon", "Mercadona", "bofrost"];

export default providers;